var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{staticStyle:{"z-index":"10"},attrs:{"show":_vm.show,"no-wrap":"","fixed":""}})}
var staticRenderFns = []

export { render, staticRenderFns }